import type { ProgramEventContentObjectDetail } from 'models';
import { Avatar, Card, Col, DetailsCategoryItem, InformationLineIcon, Row } from 'ui';
import { images } from 'common/utils';
import { useGetFirstParentInformation } from './hooks';

type P = {
  eventContentObject: ProgramEventContentObjectDetail;
};

const ProgramEventDetailsCard = ({ eventContentObject }: P) => {
  const { organization } = eventContentObject;
  const { alt, name, profilePhoto } = useGetFirstParentInformation({ eventContentObject });

  return (
    <Card title={<Card.Title icon={<InformationLineIcon />}>Details</Card.Title>}>
      <Row gutter={[0, 'ms']}>
        <Col span={24}>
          <DetailsCategoryItem
            category="organization"
            icon={
              <Avatar
                alt="Organization profile photo"
                fallbackPhoto={images.default.organizationProfilePhoto}
                photo={
                  organization.squareLogo?.url ??
                  organization.profilePhoto?.url ??
                  images.default.organizationProfilePhoto
                }
                size={32}
              />
            }
            name={organization.name}
          />
        </Col>
        <Col span={24}>
          <DetailsCategoryItem
            category="Program"
            icon={
              <Avatar alt={alt} fallbackPhoto={images.default.programProfilePhoto} photo={profilePhoto} size={32} />
            }
            name={name}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default ProgramEventDetailsCard;
